import { __assign } from "tslib";
export var normalizePoints = function (values) {
    var maxY = Math.max.apply(Math, values.map(function (v) { return v.y; }));
    return values.map(function (val) {
        var normalizedY = Math.floor((val.y * 100) / maxY);
        return __assign(__assign({}, val), { y: normalizedY });
    });
};
//# sourceMappingURL=normalize-points.js.map